import { Avatar, type AvatarProps } from "antd";
import clsx from "clsx";
import "./BAvatar.scss";

const BAvatar = ({ className, ...props }: AvatarProps) => (
  <Avatar className={clsx("b-avatar", className)} {...props} />
);

export default BAvatar;
